import { request2 } from "../request2";
export const getAllWalletHistorys = (params) => {
	return request2({
		method: 'post',
		url: '/dashboard/wallet/history',
		params
	})
}

export const updateWalletActionStatus = ({ id, status }) => {
	return request2({
		method: 'post',
		url: `/dashboard/wallet/action/status/${id}`,
		params:{status}
	})
}

export const updateWalletActionAmount = ({ id, amount }) => {
	return request2({
		method: 'post',
		url:`/dashboard/wallet/action/modify/${id}`,
		params:{amount}
	})
}
export const addWalletRecord = (params) => {
	return request2({
		method: 'post',
		url: '/dashboard/wallet/action/add',
		params
	})
}
export const walletsDeleteProof = (params) => {
	return request2({
		method: 'post',
		url: '/dashboard/deleteProof',
		params
	})
}
export const walletsAddProof = (params) => {
	return request2({
		method: 'post',
		url: '/dashboard/addProof',
		params
	})
}
